module.exports = __webpack_public_path__ + "img/2017-12-24.7f8efa41.jpg";